import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setMenuOpen(false);
    }, [location]);

    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => { document.body.style.overflow = ''; };
    }, [menuOpen]);

    const navLinks = [
        { to: '/', label: 'Home' },
        { to: '/rooms', label: 'Rooms' },
        { to: '/gallery', label: 'Gallery' },
        { to: '/about', label: 'About' },
        { to: '/contact', label: 'Contact' },
    ];

    const isActive = (path) => location.pathname === path;

    return (
        <>
            <nav
                className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${scrolled
                        ? 'bg-white/90 dark:bg-royal-500/90 backdrop-blur-xl shadow-lg shadow-black/5 dark:shadow-black/20 py-3'
                        : 'bg-transparent py-5'
                    }`}
            >
                <div className="container-custom flex items-center justify-between px-4 sm:px-6 lg:px-8">
                    {/* Logo */}
                    <Link to="/" className="flex items-center gap-3 group">
                        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gold-400 to-gold-600 flex items-center justify-center shadow-lg shadow-gold-500/25 group-hover:shadow-gold-500/40 transition-shadow duration-300">
                            <span className="font-display text-white font-bold text-sm">UC</span>
                        </div>
                        <div className="flex flex-col">
                            <span className="font-display text-lg font-bold tracking-wide text-gray-900 dark:text-white leading-none">
                                Eden Valley
                            </span>
                            <span className="text-[10px] tracking-[0.2em] uppercase text-gold-600 dark:text-gold-400 font-sans font-medium">
                                Kookal, Kodaikanal
                            </span>
                        </div>
                    </Link>

                    {/* Desktop Nav */}
                    <div className="hidden lg:flex items-center gap-8">
                        {navLinks.map(link => (
                            <Link
                                key={link.to}
                                to={link.to}
                                className={`nav-link ${isActive(link.to) ? 'active' : ''}`}
                            >
                                {link.label}
                            </Link>
                        ))}
                        <Link to="/contact" className="btn-primary text-sm">
                            Book Now
                        </Link>
                    </div>

                    {/* Mobile menu button */}
                    <div className="flex items-center gap-3 lg:hidden">
                        <button
                            onClick={() => setMenuOpen(!menuOpen)}
                            className="w-10 h-10 rounded-full flex items-center justify-center bg-gray-100 dark:bg-royal-600 border border-gray-200/50 dark:border-gold-500/10 transition-all duration-300"
                            aria-label="Toggle menu"
                        >
                            <div className="w-5 flex flex-col gap-1.5 items-center">
                                <span className={`block h-0.5 bg-gray-700 dark:bg-white transition-all duration-300 ${menuOpen ? 'w-5 rotate-45 translate-y-2' : 'w-5'}`} />
                                <span className={`block h-0.5 bg-gray-700 dark:bg-white transition-all duration-300 ${menuOpen ? 'opacity-0 w-0' : 'w-3.5'}`} />
                                <span className={`block h-0.5 bg-gray-700 dark:bg-white transition-all duration-300 ${menuOpen ? 'w-5 -rotate-45 -translate-y-2' : 'w-5'}`} />
                            </div>
                        </button>
                    </div>
                </div>
            </nav>

            {/* Mobile Menu */}
            <div
                className={`fixed inset-0 z-30 lg:hidden transition-all duration-500 ${menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
                    }`}
            >
                <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setMenuOpen(false)} />
                <div
                    className={`absolute top-0 right-0 h-full w-72 bg-white dark:bg-royal-500 shadow-2xl transition-transform duration-500 ${menuOpen ? 'translate-x-0' : 'translate-x-full'
                        }`}
                >
                    <div className="flex flex-col pt-24 px-6 gap-2">
                        {navLinks.map(link => (
                            <Link
                                key={link.to}
                                to={link.to}
                                className={`py-3 px-4 rounded-xl font-sans text-sm font-medium tracking-wide uppercase transition-all duration-300 ${isActive(link.to)
                                        ? 'bg-gold-500/10 text-gold-600 dark:text-gold-400'
                                        : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-royal-600'
                                    }`}
                            >
                                {link.label}
                            </Link>
                        ))}
                        <div className="border-t border-gray-200 dark:border-royal-600 mt-4 pt-4">
                            <Link to="/contact" className="btn-primary w-full text-sm text-center">
                                Book Now
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
